/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

var Flickity = require('flickity');
require('flickity-imagesloaded');

require('../vendor/magnific.js');

import './parallax.js';
import { parallax } from './parallax.js';

// =============================================================================
// Helper - Slide Counter
// =============================================================================

function slideCounter(el) {
  const els = el.querySelectorAll('.section__slide')
  let slideCount = 0

  els.forEach(() => {
    slideCount++
  })
  
  return slideCount
}

// =============================================================================
// Video Module Slider
// =============================================================================
export function videoModuleSlider() {
  const videoModuleSliderEls = document.querySelectorAll('.videoModule__slider');

  for (const videoModuleSliderEl of videoModuleSliderEls) {
    let videoCount = videoModuleSliderEl.getAttribute('data-video-count');
    let groupCellsCount = 0
  
    if (videoCount >= 2) {
      groupCellsCount = 2
    } else {
      groupCellsCount = videoCount
    }
  
    if ( videoCount <= 2) {
      videoModuleSliderEl.classList.add('hide-flickity-nav')
    } else {
      videoModuleSliderEl.classList.remove('hide-flickity-nav')
    }
    let mfpOpen = true
  
    if(window.matchMedia("(min-width: 768px)").matches) {
      const flkty = new Flickity( videoModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: groupCellsCount,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          },
          dragStart: function() {
            mfpOpen = false;
            console.log('mfpOpen false');
          },
          dragEnd: function() {
            setTimeout(() => {
              mfpOpen = true;
              console.log('mfpOpen true');            
            }, 500);
          }
        }
      })
    }
  
    // Prevent click & drag from activating popup
    $('.videoPopup').magnificPopup({
      type: 'inline',
      midClick: false, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      gallery: {
        enabled: true
      },
      disableOn: function() {
        return mfpOpen;
      },
      callbacks: {
        open: function() {
          $('.cb-cursor').addClass('-close');
        },
        close: function() {
          $('.cb-cursor').removeClass('-close');
        }
      }
    });
  
    let startX = 0;
    videoModuleSliderEl.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
    videoModuleSliderEl.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })
  
  }
}

// =============================================================================
// Steps Module Slider
// =============================================================================
export function stepsModuleSlider() {
  const stepsModuleSliderEl = document.querySelector('.stepsModule__slider');

  if(window.matchMedia("(max-width: 767.98px)").matches) {
    const flkty = new Flickity( stepsModuleSliderEl, {
      // options
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      groupCells: 1,
      draggable: true,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 2000);
        },
      }
    })
  } else if(window.matchMedia("(max-width: 959.98px)").matches) {
    const flkty = new Flickity( stepsModuleSliderEl, {
      // options
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      groupCells: 2,
      draggable: true,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 2000);
        },
      }
    })
  }

  var tapArea, startX ;
  tapArea = document.querySelectorAll('.stepsModule__slider');
  startX = 0;

  for (var item of tapArea) {
    item.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
    item.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })
  }
}

// =============================================================================
// Cards Module Slider
// =============================================================================
export function cardsModuleSlider() {
  const cardsModuleSliderEls = document.querySelectorAll('.cardsModule__slider');

  for (const cardsModuleSliderEl of cardsModuleSliderEls) {
    let flkty
  
    if(window.matchMedia("(min-width: 960px)").matches) {
      flkty = new Flickity( cardsModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 3,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
              setSliderHeightToMax(this);
            }, 2000);
          },
        }
      })
  
      if(slideCounter(cardsModuleSliderEl) <= 3) {
        cardsModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        cardsModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    } else if(window.matchMedia("(min-width: 768px)").matches) {
      flkty = new Flickity( cardsModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: false,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 2,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
              setSliderHeightToMax(this);
            }, 2000);
          },
        }
      })
  
      if(slideCounter(cardsModuleSliderEl) <= 2) {
        cardsModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        cardsModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    } else {
      flkty = new Flickity( cardsModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: false,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 1,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
              setSliderHeightToMax(this);
            }, 2000);
          },
        }
      })
  
      if(slideCounter(cardsModuleSliderEl) == 1) {
        cardsModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        cardsModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    }

    let startX = 0

    cardsModuleSliderEl.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
  
    cardsModuleSliderEl.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })
  
    // Match card heights - https://github.com/metafizzy/flickity/issues/534
    function setSliderHeightToMax(slider) {
      slider.cells.forEach(cell => cell.element.style.height = '');
          
      let heights = slider.cells.map(cell => cell.element.offsetHeight),
          max = Math.max.apply(Math, heights);
      
      slider.cells.forEach(cell => cell.element.style.height = max + 'px');
    }
  
    window.addEventListener('resize', function(){
      setSliderHeightToMax(flkty);
    });
  }

}

// =============================================================================
// Recipes Module Slider
// =============================================================================
export function recipesModuleSlider() {
  const recipesModuleSliderEls = document.querySelectorAll('.recipesModule__slider');

  for (const recipesModuleSliderEl of recipesModuleSliderEls) {
    if(window.matchMedia("(min-width: 960px)").matches) {
      const flkty = new Flickity( recipesModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 3,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          },
        }
      })
  
      if(slideCounter(recipesModuleSliderEl) <= 3) {
        recipesModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        recipesModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    } else if(window.matchMedia("(min-width: 768px)").matches) {
      const flkty = new Flickity( recipesModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 2,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          },
        }
      })
  
      if(slideCounter(recipesModuleSliderEl) <= 2) {
        recipesModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        recipesModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    } else {
      const flkty = new Flickity( recipesModuleSliderEl, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 1,
        draggable: true,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          },
        }
      })
  
      if(slideCounter(recipesModuleSliderEl) == 1) {
        recipesModuleSliderEl.classList.add('hide-flickity-nav')
      } else {
        recipesModuleSliderEl.classList.remove('hide-flickity-nav')
      }
  
    }
  
    let startX = 0;  
    recipesModuleSliderEl.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
    recipesModuleSliderEl.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })
  }
}

// =============================================================================
// Media Content Slider
// =============================================================================
export function mediaContentModuleSlider() {
  const mediaContentModuleSliderEls = document.querySelectorAll('.mediaContentSliderModule__slider');

  for (const mediaContentModuleSliderEl of mediaContentModuleSliderEls) {
    const flkty = new Flickity( mediaContentModuleSliderEl, {
      // options
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      groupCells: 1,
      draggable: true,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 2000);
        },
      }
    })
  
    if(slideCounter(mediaContentModuleSliderEl) == 1) {
      mediaContentModuleSliderEl.classList.add('hide-flickity-nav')
    } else {
      mediaContentModuleSliderEl.classList.remove('hide-flickity-nav')
    }
  
    let startX = 0;
    mediaContentModuleSliderEl.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
    mediaContentModuleSliderEl.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })

  }
}
